// @flow
import React from 'react';
import UserSeriesContainer from 'containers/user/UserSeriesContainer';

type Props = {};
const UserSeriesSubpage = (props: Props) => {
  return <UserSeriesContainer />;
};

export default UserSeriesSubpage;



// WEBPACK FOOTER //
// ./src/pages/user/UserSeriesSubpage.js